import {Col, Collapse, Descriptions, Empty, Row, Skeleton, Tag} from 'antd';
import React from "react";
import styled from "styled-components";
import {getDetailsIcon} from "../../licenceActionButtons";
import {LicenceStatusColor, LicenceStatusText} from "../../../../constants/LicenceStatus";
import moment from 'moment';
import {DATE_FORMAT} from "../../../../constants/dateFormat";

const {Panel} = Collapse;

const LicenceListContainer = styled.div`
    .licence-list {
        margin-top: 10px;
    }
    .company-header {
        justify-content: space-between;
    }
`;

const LicenceList = ({
                         data, loading, primaryColor, onRevokeClick, showLicenceInfo, onDeleteClick, onSendPassword, onLicenceSend, onPublicKeyDownload,
                         licenceDetailsVisible,
                         toggleLicenceDetails,
                         onLicenceDownload
                     }) => {

    return <LicenceListContainer>
        {
            loading ? <Skeleton active/> :
                (data.length ? <Collapse className='licence-list' accordion>
                            {
                                data.map(record => {
                                    const {id, licenceNumber, currentProductVersion, issueDate, companyHasSoftwareProductWithCompanyAndSoftwareProductResponse, status, statusDescription} = record;
                                    return <Panel key={id.toString()} header={<Row className='company-header'>
                                        <Col>{companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.companyResponse.companyName} -
                                            {companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.softwareProductResponse.code} -
                                            {companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.code}</Col>
                                        <Col>
                                            {
                                                getDetailsIcon({
                                                    record,
                                                    onRevokeClick,
                                                    onDeleteClick,
                                                    onLicenceSend,
                                                    onSendPassword,
                                                    showLicenceInfo,
                                                    onLicenceDownload,
                                                    onPublicKeyDownload,
                                                    licenceDetailsVisible,
                                                    toggleLicenceDetails,
                                                    twoToneColor: primaryColor
                                                }, false)
                                            }
                                        </Col>
                                    </Row>}
                                    >
                                        <Descriptions title="Licence Info" column={1}>
                                            <Descriptions.Item label="Licence Number">{licenceNumber}</Descriptions.Item>
                                            <Descriptions.Item
                                                label="Current Version">{currentProductVersion}</Descriptions.Item>
                                            <Descriptions.Item
                                                label="Issue Date">{issueDate && moment(issueDate).format(DATE_FORMAT)}</Descriptions.Item>
                                            <Descriptions.Item label="Status">
                                                <Tag color={LicenceStatusColor[status]}>{LicenceStatusText[status]}</Tag>
                                            </Descriptions.Item>
                                            <Descriptions.Item
                                                label="Status Description">{statusDescription}</Descriptions.Item>
                                        </Descriptions>
                                    </Panel>
                                })

                            }
                        </Collapse> :
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                )
        }
    </LicenceListContainer>
};

export default LicenceList;